import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type Props = {
  columns: number;
  rows?: number;
};

export const ManagementListSkeleton: FC<Props> = ({ columns, rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex}>
              <Skeleton height={25} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
